module.exports = __webpack_public_path__ + "static/media/Fifth.f685f486.png";